// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"556":"c2986969","674":"38bb0710"}[chunkId] + ".chunk.js";
};